import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/integrations/supabase/client';

const API_BASE = () =>
  (import.meta.env.VITE_SUPABASE_URL as string) ?? 'https://beta.crm-api.primetecia.com.br/api';

export interface LinhaTabelaRenovacao {
  linha: string;
  faixa: number | null;
  tabela: '1' | '2' | 'PENDENTE';
}

export interface ValorLinhaDiretoria {
  linha: string;
  faixa: number | null;
  pct: number;
  comissao: number;
}

export interface TabelaRenovacaoPedido {
  tabela: '1' | '2' | 'PENDENTE';
  linhas: LinhaTabelaRenovacao[];
  valores: {
    cluster: 'M' | 'G';
    pnAtivados: number;
    total: number;
    itens: Array<{ produto: string; pct: number; comissao: number; pendencia: string | null; linhas?: ValorLinhaDiretoria[] }>;
  } | null;
}

export function useTabelaRenovacaoPedido(pedidoId: string | null | undefined) {
  return useQuery<TabelaRenovacaoPedido>({
    queryKey: ['tabela-renovacao-pedido', pedidoId],
    enabled: !!pedidoId,
    staleTime: 30_000,
    queryFn: async () => {
      const { data: { session } } = await supabase.auth.getSession();
      const res = await fetch(`${API_BASE()}/v1/comissao/diretoria/pedido/${pedidoId}`, {
        headers: { Authorization: `Bearer ${session?.access_token ?? ''}` },
      });
      if (!res.ok) throw new Error(`tabela renovação ${res.status}`);
      return res.json();
    },
  });
}

export const finalDaLinha = (v: string | null | undefined) => String(v ?? '').replace(/\D/g, '').slice(-8);
